import React, { useState, useContext, useEffect } from 'react';
import { Card, Col, Row, Form, Button } from 'react-bootstrap';
import SettingsSideBar from './SettingsSideBar';
import SettingsHeader from './SettingsHeader';
import Flex from 'components/common/Flex';
import { toast } from 'react-toastify';
import TinymceEditor from 'components/common/TinymceEditor';
import { updateCompany } from 'lib/apiService';
import { AuthWizardContext } from 'context/Context';
import { removerHtmlFormat } from 'helpers/utils';

const SettingsStructure = () => {
  const { company, setCompany } = useContext(AuthWizardContext);
  const [observer, setObserver] = useState(false);
  const [formData, setFormData] = useState({});
  const [edit, setEdit] = useState({});

  const handleTextChange = newValue => {
    setObserver(true);
    setFormData(newValue);
  };

  useEffect(() => {
    if (company) {
      setFormData(removerHtmlFormat(company?.companyStructure));
    }
  }, [company]);

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      updateCompany(company._id, { companyStructure: formData })
        .then(result => {
          if (result.data.success) {
            toast.success(`Амжиллтай илгээгдлээ`, {
              theme: 'colored'
            });
            setFormData(result.data.data);
            setCompany(result.data.data);
            localStorage.setItem('company', JSON.stringify(result.data.data));
            setEdit({ ...edit, address: !edit.address });
          }
        })
        .catch(error => {
          console.log(
            '🚀 ~ file: SettingsLegal.js:44 ~ handleSubmit ~ error:',
            error
          );
          toast.warning(`${error.response.data.error.message}`, {
            theme: 'colored'
          });
        });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Row className="g-3">
      <Col xl={4} xxl={3}>
        <SettingsSideBar />
      </Col>
      <Col xl={8} xxl={9}>
        <SettingsHeader data={' Сайт ашиглалтын нөхцөл'} />
        <Card className="mt-4">
          <Card.Header className="bg-light d-flex justify-content-between align-items-md-center">
            <h6 className="mb-0">Компанийн бүтэц</h6>
            <button
              className="btn btn-link"
              onClick={() => setEdit({ ...edit, address: !edit.address })}
            >
              {' '}
              {edit.address ? (
                <h6
                  className="text-primary"
                  onClick={() => setEdit({ ...edit, address: !edit.address })}
                >
                  Буцах
                </h6>
              ) : (
                <h6 className="text-primary">Засах</h6>
              )}
            </button>
          </Card.Header>
          <Card.Body>
            <Row>
              {edit.address ? (
                <Form onSubmit={handleSubmit}>
                  <Row className="gx-2 gy-3 px-4">
                    <Col xs="12">
                      <Form.Group>
                        <Form.Label>Дэлгэрэнгүй:</Form.Label>
                        <div className="create-product-description-textarea ">
                          <TinymceEditor
                            height="33.438rem"
                            handleChange={handleTextChange}
                            value={formData}
                          />
                        </div>
                        <Form.Control.Feedback type="invalid">
                          {/* {errors.description?.message} */}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={12} xxl={12}>
                      <Flex
                        alignItems="center"
                        justifyContent="end"
                        className={`px-2 ${
                          edit.address ? 'py-x1' : 'py'
                        } position-relative`}
                      >
                        <Button
                          variant="falcon-default"
                          className="me-2 mb-1"
                          onClick={() =>
                            setEdit({ ...edit, address: !edit.address })
                          }
                        >
                          Буцах
                        </Button>
                        <Button
                          variant="primary"
                          type="submit"
                          className="me-2 mb-1"
                          disabled={!observer}
                        >
                          Хадгалах
                        </Button>
                      </Flex>
                    </Col>
                  </Row>
                </Form>
              ) : (
                <div>
                  {formData ? (
                    <div
                      className=" mb-2 mt-2 px-3"
                      dangerouslySetInnerHTML={{
                        __html: removerHtmlFormat(formData)
                      }}
                    ></div>
                  ) : (
                    <div className="alert alert-warning" role="alert">
                      Mэдээлэл байхгүй байна
                    </div>
                  )}
                </div>
              )}
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default SettingsStructure;
